import { Entry } from '../Entry'

export function Entry20260817() {
  return (
    <Entry title="2026 Aug 17 - v3.11.19">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/27047/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
